import { render, staticRenderFns } from "./SynchroWidget.vue?vue&type=template&id=ef82fd42&scoped=true"
import script from "./SynchroWidget.vue?vue&type=script&lang=js"
export * from "./SynchroWidget.vue?vue&type=script&lang=js"
import style0 from "./SynchroWidget.vue?vue&type=style&index=0&id=ef82fd42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef82fd42",
  null
  
)

export default component.exports